// extracted by mini-css-extract-plugin
module.exports = {"background":"propertyView_background__3kQ7B","title":"propertyView_title__3CrFg","sections":"propertyView_sections__3CBRU"};
    if(module.hot) {
      // 1790670303439
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  